import { MatterListItemDto } from "./dto";
import { MatterListItem } from "./models";

export function mapMatterListItemFromDto(dto: MatterListItemDto): MatterListItem {
  return {
    id: dto.id,
    ref: dto.ref,
    client: dto.client,
  };
}
